var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group form-switch"},[_c('toggle-button',{attrs:{"sync":true,"width":100,"height":30,"color":"rgb(121, 189, 143)","labels":_vm.placeholder},on:{"change":_vm.updateValue},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }